import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import Slider from 'react-slick';

import '../../../components/package-styles/slick.css';

import Wrapper from '../../elements/wrapper';

import ChevronRight from '../../../images/icons/chevron-right.inline.svg';
import ChevronLeft from '../../../images/icons/chevron-left.inline.svg';

const PaletteColorsContainer = styled.div`
    .all-colors-wrapper {
        margin-top: 20px;
        display: flex;

        .slider-container {
            flex: 1;
            overflow: hidden;
            position: relative;

            .select-container {
                text-align: right;
                padding-right: 10px;
                padding-bottom: 10px;

                select {
                    text-transform: capitalize;
                }
            }
        }

        .slider-nav {
            align-items: center;
            display: flex;

            .arrow-container {
                button {
                    line-height: 1;
                    border: none;
                    background-color: transparent;

                    &:hover {
                        opacity: 0.7;
                    }
                    &:focus,
                    &:active {
                        outline: none;
                    }
                }
            }
        }
    }
`;

const PaletteColors = ({ addColorToPalette }) => {
    const data = useStaticQuery(graphql`
        query {
            allGoogleSheetGoodformColorsRow {
                edges {
                    node {
                        rgbcode
                        colorname
                        colorfamily
                    }
                }
            }
        }
    `);

    let allGoodformColors = data && data.allGoogleSheetGoodformColorsRow.edges;
    const [slideCount, setSlideCount] = useState();
    const [slideIndex, setSlideIndex] = useState(0);
    const [updateCount, setUpdateCount] = useState(0);
    const [colorFamilies, setColorFamilies] = useState([]);
    const [currentColors, setCurrentColors] = useState([...allGoodformColors]);

    function handleSlideChange(newIndex) {
        setSlideIndex(newIndex);
        sliderRef.current.slickGoTo(newIndex);
    }

    function NextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div className="arrow-container next">
                <button onClick={() => handleSlideChange(slideIndex + 1)}>
                    <ChevronRight />
                </button>
            </div>
        );
    }

    function PrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div className="arrow-container prev">
                <button onClick={() => handleSlideChange(slideIndex - 1)}>
                    <ChevronLeft />
                </button>
            </div>
        );
    }

    var settings = {
        dots: true,
        infinite: false,
        fade: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: () => setUpdateCount(updateCount + 1),
        beforeChange: (current, next) => setSlideIndex(next),
    };

    function getAllColorFamilies() {
        let filteredColorFamilies = [];

        allGoodformColors.map((colorNode) => {
            let color = colorNode.node;
            if (filteredColorFamilies.indexOf(color.colorfamily) === -1) {
                filteredColorFamilies.push(color.colorfamily);
            }
        });

        console.log('filteredColorFamilies', filteredColorFamilies);
        setColorFamilies(filteredColorFamilies);
    }

    function generateSlides(color) {
        console.log('currentColors', currentColors);
        let amountOfSlides;
        amountOfSlides = Math.ceil(currentColors.length / 108);

        let slides = [];
        for (let i = 0; i < amountOfSlides; i++) {
            slides.push(i + 1);
        }
        console.log('slides', slides);
        setSlideCount(slides);
    }

    function handleColorFilter(e) {
        let colorFamily = e.target.value;
        let filteredColors = [];
        if (colorFamily !== 'all') {
            filteredColors = allGoodformColors.filter(
                (color) => color.node.colorfamily === colorFamily
            );
        } else {
            filteredColors = allGoodformColors;
        }

        setCurrentColors(filteredColors);
    }

    useEffect(() => {
        setCurrentColors(allGoodformColors);
        generateSlides();
        getAllColorFamilies();
    }, []);

    useEffect(() => {
        generateSlides();
    }, [currentColors]);

    const sliderRef = useRef(null);
    return (
        <PaletteColorsContainer>
            <Wrapper className="all-colors-wrapper">
                <div className="slider-container">
                    <div className="select-container">
                        <select
                            name=""
                            id=""
                            onChange={(e) => handleColorFilter(e)}
                        >
                            <option value="all">All Color Families</option>
                            {colorFamilies &&
                                colorFamilies.map((family, index) => {
                                    return (
                                        <option key={index} value={family}>
                                            {family}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                    <Slider ref={sliderRef} {...settings}>
                        {slideCount &&
                            slideCount.map((slide, index) => {
                                let currentPosition = index * 108;
                                return (
                                    <SlideContainer key={index}>
                                        {currentColors
                                            .slice(
                                                currentPosition,
                                                currentPosition + 108
                                            )
                                            .map((colorNode) => {
                                                const color =
                                                    colorNode.node || {};
                                                return (
                                                    <button
                                                        style={{
                                                            backgroundColor:
                                                                color.rgbcode,
                                                        }}
                                                        onClick={() =>
                                                            addColorToPalette(
                                                                color
                                                            )
                                                        }
                                                    ></button>
                                                );
                                            })}
                                    </SlideContainer>
                                );
                            })}
                    </Slider>
                </div>
                <div className="slider-nav">
                    {slideCount && slideCount.length > 1 && (
                        <div className="inner-wrap">
                            <PrevArrow />
                            <NextArrow />
                        </div>
                    )}
                </div>
            </Wrapper>
        </PaletteColorsContainer>
    );
};

export default PaletteColors;

const SlideContainerStyles = styled.div`
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
    line-height: 30px;

    button {
        background: tomato;
        margin: 3px;
        color: white;
        font-weight: bold;
        font-size: 1.5em;
        text-align: center;
        border: none;
        flex: 0 0 4.3%;
        height: auto;
        min-height: 22px;
        border-radius: 1px;
        &::before {
            content: '';
            float: left;
            padding-top: 100%;
        }
    }
`;

const SlideContainer = ({ children }) => {
    return <SlideContainerStyles>{children}</SlideContainerStyles>;
};
